import { PriceMath, PoolUtil } from "@orca-so/whirlpools-sdk";
import { BN } from "@coral-xyz/anchor";
import Decimal from "decimal.js";
import axios from "axios";
import _ from "lodash";
export async function calculatePositionsValue({ poolData, positions }) {
  // 初始化總計
  let totalValue = new Decimal(0);
  let totalTokenAAmount = new Decimal(0);
  let totalTokenBAmount = new Decimal(0);

  // 存儲每個 position 的計算結果
  const { sqrtPrice, tokenA, tokenB, tokenMintA, tokenMintB } = poolData;

  const tokenAResult = await axios.get(
    `https://api.dexscreener.com/token-pairs/v1/solana/${tokenMintA}`,
    {
      withCredentials: false,
    }
  );
  const tokenBResult = await axios.get(
    `https://api.dexscreener.com/token-pairs/v1/solana/${tokenMintB}`,
    {
      withCredentials: false,
    }
  );

  const tokenAData = _.get(tokenAResult, "data[0]");
  const tokenBData = _.get(tokenBResult, "data[0]");

  const positionValues = positions.map((position) => {
    const { liquidity, tickLowerIndex, tickUpperIndex } = position;

    // 使用 PriceMath 計算價格
    const currentSqrtPrice = new BN(sqrtPrice);
    const currentPrice = PriceMath.sqrtPriceX64ToPrice(currentSqrtPrice);

    const lowerSqrtPrice = PriceMath.tickIndexToSqrtPriceX64(tickLowerIndex);
    const upperSqrtPrice = PriceMath.tickIndexToSqrtPriceX64(tickUpperIndex);

    const liquidityBN = new BN(liquidity);

    // 計算 token 數量
    const amounts = PoolUtil.getTokenAmountsFromLiquidity(
      liquidityBN,
      currentSqrtPrice,
      lowerSqrtPrice,
      upperSqrtPrice,
      false // round up
    );
    // 轉換為 decimal 進行價值計算
    const tokenADecimal = new Decimal(amounts.tokenA.toString()).div(
      new Decimal(10).pow(tokenA.decimals)
    );
    const tokenBDecimal = new Decimal(amounts.tokenB.toString()).div(
      new Decimal(10).pow(tokenB.decimals)
    );

    const tokenAPriceDec = new Decimal(tokenAData.priceUsd);
    const tokenBPriceDec = new Decimal(tokenBData.priceUsd);

    const tokenAValue = tokenADecimal.mul(tokenAPriceDec);
    const tokenBValue = tokenBDecimal.mul(tokenBPriceDec);
    const positionTotalValue = tokenAValue.add(tokenBValue);

    // 加總
    totalTokenAAmount = totalTokenAAmount.add(tokenADecimal);
    totalTokenBAmount = totalTokenBAmount.add(tokenBDecimal);
    totalValue = totalValue.add(positionTotalValue);

    return {
      position: {
        liquidity: liquidity.toString(),
        currentPrice: currentPrice.toString(),
      },
      values: {
        tokenA: tokenAValue.toNumber(),
        tokenB: tokenBValue.toNumber(),
        total: positionTotalValue.toNumber(),
      },
      amounts: {
        tokenA: tokenADecimal.toNumber(),
        tokenB: tokenBDecimal.toNumber(),
      },
    };
  });

  return {
    value: totalValue.toNumber(),
    amounts: {
      tokenA: totalTokenAAmount.toNumber(),
      tokenB: totalTokenBAmount.toNumber(),
    },
    positions: positionValues,
  };
}
